import React from 'react';
import { InView } from 'react-intersection-observer';
import '../styles/PartnerSection.css';
import MicrosoftPartnerLogo from '../../assets/microsoft-partner-logo.svg';

const PartnerSection = () => {
  return (
    <section className="partner-section section-spacing">
      <div className="partner-container">
        <InView triggerOnce={true} threshold={0.1}>
          {({ inView, ref }) => (
            <aside
              ref={ref}
              className={`partner-logo ${inView ? "animate" : ""}`}
            >
              <figure className="logo-card">
                <div className="logo-top">
                  <img
                    src={MicrosoftPartnerLogo}
                    alt="Microsoft Solutions Partner Logo"
                    className="ms-logo"
                  />
                </div>
                <figcaption className="logo-bottom">
                  <h3>Modern Work</h3>
                  <p>Synectiks INC</p>
                </figcaption>
              </figure>
            </aside>
          )}
        </InView>
        <InView triggerOnce={true} threshold={0.1}>
          {({ inView, ref }) => (
            <article
              ref={ref}
              className={`partner-content ${inView ? "animate" : ""}`}
            >
              <header>
                <h1>Certified Microsoft Solutions Partner</h1>
              </header>
              <p>
                As a certified Microsoft Solutions Partner,{" "}
                <span className="company-name">
                  SYNECT<span className="company-name-red-i">I</span>KS
                </span>{" "}
                delivers tailored solutions that help you harness the full power
                of Microsoft's most advanced technologies while ensuring
                enterprise-grade security and seamless digital transformation.
              </p>
            </article>
          )}
        </InView>
      </div>
    </section>
  );
};

export default PartnerSection;